// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchNavbarComponents-cls1_21R","cls2":"SearchNavbarComponents-cls2_hUX SearchNavbarComponents-cls1_21R"};